import { InlineStack, Text } from "@shopify/polaris";
import React from "react";
import { useTranslation } from "react-i18next";

export const FormatPriceAmount = (amount: string) => {
    let formattedPrice: React.ReactNode = <></>;
    let a = amount.split('.');
    formattedPrice =
        <InlineStack wrap={false} gap="100" blockAlign='start'>
            <Text variant="heading3xl" as="p" fontWeight='semibold'>
                ${a[0]}
            </Text>
            <Text variant="headingLg" as="p" fontWeight='regular'>
                <sup>{a[1]}</sup>
            </Text>
        </InlineStack>
    return formattedPrice;
}

// function to customize date according to the figma
export const formatDate = (date: string) => {
    const { t } = useTranslation();
    var monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let d = new Date(date);
    let dd = d.getDate() + '';
    if (dd === '1') dd += 'st';
    else if (dd === '2') dd += 'nd';
    else if (dd === '3') dd += 'rd';
    else dd += 'th'
    let mm = t(monthList[d.getMonth()]) + ','
    let yy = d.getFullYear()
    return (dd + ' ' + mm + ' ' + yy)
}

export const prepareDiscountedPrice = (plan: any) => {
    let discountedPrice: number = 0;
    if (Object?.values(plan?.plan_details?.discounts)?.length > 0) {
        if (plan?.plan_details?.discounts?.[0]?.type === "percentage")
            discountedPrice = Math.ceil(plan?.plan_details?.custom_price - (plan?.plan_details?.discounts?.[0]?.value / 100) * plan?.plan_details?.custom_price)
        else discountedPrice = Math.ceil(plan?.plan_details?.custom_price - plan?.plan_details?.discounts?.[0]?.value)
    }
    else discountedPrice = +plan?.plan_details?.custom_price;

    return discountedPrice;
}



export const returnDiscountedPrice = (discounts: any, customPrice: any, devideBy12?: boolean, build_type?: string) => {
    let discountedPrice: number = +customPrice || 0;
    let tempPrice: number | string = +discountedPrice;
    discounts?.forEach((discount: any) => {
        if ((discount.hasOwnProperty('active') && discount.active) || !discount.hasOwnProperty('active')) {
            switch (discount?.type) {
                case 'percentage':
                    tempPrice = +tempPrice - (+discount?.value / 100) * +tempPrice;
                    break;
                case 'fixed':
                    tempPrice = +tempPrice - +discount?.value;
                    break;
                default:
                    tempPrice = tempPrice;
            }
        }

    })
    if (build_type == "yearly") {
        if (devideBy12) {
            tempPrice = Math.ceil(tempPrice / 12);
        }

    }
    return tempPrice;
}